"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemCode = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
const RedeemCodeField_1 = require("../../molecules/RedeemCodeField/RedeemCodeField");
const mediaQueries_1 = require("../../styles/mediaQueries");
function RedeemCode({ onChange, code, className, }) {
    const { t } = (0, i18n_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'RedeemCode_Container', children: [(0, jsx_runtime_1.jsx)(Label, { "data-e2e": 'RedeemCode_Label', children: t(i18n_1.Strings.userOnboarding.common.redeemCodeFieldLabel) }), (0, jsx_runtime_1.jsx)(RedeemCodeField_1.RedeemCodeField, { onChange: onChange, code: code, "data-e2e": 'RedeemCode_RedeemCodeField' })] }));
}
exports.RedeemCode = RedeemCode;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  ${mediaQueries_1.device.mobileLandscape `
    width: initial;
  `}
`;
const Label = styled_components_1.default.label `
  align-self: flex-start;

  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.designSystem.white};

  margin-bottom: 8px;
`;
